export const MailMenus =  {
    incoming: [
        { key: "view", text: "labels.kooi.mails.show" },
    ],
    accepted: [
    ],
    canceled: [

    ],
    outgoing: [
        { key: "view", text: "labels.kooi.mails.show" },
        { key: "sendNow", text: "labels.kooi.mails.send_now" },
        {
            disabled: false,
            loading: false,
            key: "abort",
            text: "labels.kooi.mails.abort",
            icon: "fas fa-plane-slash",
            emit: "kooi:mails:menu:abort",
        },
    ],
    sent: [
        { key: "view", text: "labels.kooi.mails.show" }
    ]
}
